module.exports = __webpack_public_path__ + "static/media/frontend.00c47a20.svg";